
export const MediaCardUiSchema = {
  type: 'VerticalLayout',
  elements: [
    {
      type: 'Control',
      scope: '#/properties/title',
      component: 'textField',
      placeholder: 'Filename.png',
      label: 'Title',
      isDark: true,
    },
    {
      type: 'Control',
      scope: '#/properties/imageId',
      component: 'textField',
      placeholder: '(Empty)',
      label: 'Image ID',
      isDark: true,
    },
    {
      type: 'Control',
      scope: '#/properties/optIn',
      component: 'toggle',
      label: 'Opt In',
      size: 'medium',
      isDark: true,
    },
  ],
}

export const ProductCardSchema = {
  type: 'VerticalLayout',
  elements: [
    {
      type: 'Control',
      scope: '#/properties/title',
      component: 'textField',
      placeholder: 'Filename.png',
      label: 'Title',
      isDark: true,
    },
  ],
}

export const mediaCardJsonSchema = {
  type: 'object',
  title: 'Display Content Media',
  properties: {
    title: {
      type: 'string',
    },
    imageId: {
      type: 'string',
    },
    optIn: {
      type: 'boolean',
    },

  },
  // required: ['title'],
}
